import React from 'react';
import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';
import UnknownMonitor from 'shared/ui/icons/UnknownMonitor';

import {IStatusStyles} from '../model/IStatusStyles';
import {StatusType} from '../model/StatusType';

export const getStatusIcon = (status: StatusType) => {
    switch(status) {
        case 'up':
            return <SuccessfulMonitor />;
        case 'down':
            return <ProblemMonitor />;
        case 'unknown':
            return <UnknownMonitor />;
        default:
            return null;
    }
};

export const getStatusColor = (status: StatusType, styles: IStatusStyles): string => {
    switch(status) {
        case 'up':
            return styles.successColor;
        case 'down':
            return styles.errorColor;
        case 'unknown':
            return styles.unknownColor;
        default:
            return '';
    }
};